import {
  SYNERISE_CAMPAIGN_RECOMMENDATION_PATH,
  SYNERISE_TRACKER_KEY
} from 'lib/synerise/config'
import { SyneriseCampaignRecommendationQueryParams } from 'lib/synerise/types'
import { encodeKeyValue } from 'shared/utils/common'
import { isNilOrEmpty } from 'shared/utils/ramda'

export const buildSyneriseCampaignQueryUrl = (
  campaignId: string,
  params: SyneriseCampaignRecommendationQueryParams
) => {
  const paramsString = toSyneriseCampaignRecommendationParamsString(params)
  const separator = paramsString ? '&' : '?'

  return `${SYNERISE_CAMPAIGN_RECOMMENDATION_PATH}${campaignId}${paramsString}${separator}token=${SYNERISE_TRACKER_KEY}`
}

export const toSyneriseCampaignRecommendationParamsString = ({
  params: customParams,
  ...syneriseKeys
}: SyneriseCampaignRecommendationQueryParams): string => {
  const syneriseParts = Object.entries(syneriseKeys)
    .filter(([_, value]) => !isNilOrEmpty(value))
    .map(([key, value]) => encodeKeyValue(key, value))

  const customParts = customParams
    ? Object.entries(customParams).map(([k, v]) =>
        encodeKeyValue('params', `${k}:${v}`)
      )
    : []

  const parts = [...syneriseParts, ...customParts]

  return parts.length ? `?${parts.join('&')}` : ''
}
